import { identity, pickBy } from 'lodash';
import moment from 'moment';

class RetencionBaseRequestInputTransformer {
  getName() {
    return 'retencion';
  }

  make(data) {
    const { Emisor = {}, Receptor = {}, Totales, Complemento } = data;
    const { Nacional, Extranjero, NacionalidadR } = Receptor;

    const impuestosRetenidos = [];

    if (!!Totales.isr) {
      impuestosRetenidos.push(Totales.isr);
    }

    if (!!Totales.iva) {
      impuestosRetenidos.push(Totales.iva);
    }

    let body = {
      FechaExp: moment().format('YYYY-MM-DD HH:mm:ss'),
      FolioInt: data.FolioInt,
      CveRetenc: data.CveRetenc,
      DescRetenc: data.DescRetenc,
      LugarExpRetenc: data.LugarExpRetenc,
      Emisor: {
        Id: Emisor.id,
      },
      Receptor: this.clear({
        NacionalidadR,
        Nacional,
        Extranjero,
      }),
      Periodo: {
        ...data.Periodo,
      },
      Totales: {
        MontoTotOperacion: Totales.MontoTotOperacion,
        MontoTotGrav: Totales.MontoTotGrav,
        MontoTotExent: Totales.MontoTotExent,
        MontoTotRet: Totales.MontoTotRet,
        ImpRetenidos: impuestosRetenidos,
      },
      Complemento: Complemento,
      Metadata: {
        as: 'ui',
      },
    };

    body = this.clear(body);

    return body;
  }

  clear(data) {
    return pickBy(
      data,
      identity((item) => {
        if (!!item) {
          return item === 1 || item === true || Object.keys(item).length > 0;
        }

        return item !== '' && item !== undefined && item !== null;
      })
    );
  }
}

export default RetencionBaseRequestInputTransformer;
